import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { init, track } from '@plausible-analytics/tracker';

const PLAUSIBLE_ENDPOINT = 'https://stats.ndw.nu/api/event';
const UUID_IN_PATH =
  /\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;

const sanitizeUrl = (url: string) => {
  const parsed = new URL(url);
  parsed.search = '';
  return parsed.toString().replace(UUID_IN_PATH, '/{id}');
};

@Injectable({
  providedIn: 'root',
})
export class PlausibleService {
  private readonly enabled = environment.enablePlausible && !!environment.plausibleDomain;

  constructor() {
    if (!this.enabled) {
      return;
    }

    init({
      domain: environment.plausibleDomain,
      endpoint: PLAUSIBLE_ENDPOINT,
      autoCapturePageviews: false,
      outboundLinks: true,
      fileDownloads: true,
      captureOnLocalhost: environment.environment === 'local',
      customProperties: { application: 'Daisi' },
      transformRequest: (payload) => ({
        ...payload,
        u: sanitizeUrl(payload.u),
      }),
    });
  }

  trackEvent(event: string, props?: Record<string, string>) {
    if (this.enabled) {
      track(event, { props });
    }
  }

  trackPageview() {
    this.trackEvent('pageview');
  }
}
